<template>
  <div id="companyForm" class="form">
    <v-form v-if="loaded" ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="company.name"
        label="Name"
        :rules="[(v) => !!v || 'Name is required']"
        required
      />
      <v-text-field
        v-model="company.thaiName"
        label="Thai Name"
        :rules="[(v) => !!v || 'Thai Name is required']"
        required
      />
      <v-text-field
        v-model="company.chineseName"
        label="Chinese Name"
        required
      />
      <v-text-field
        v-model="company.website"
        label="Website"
        :rules="[
          (v) =>
            !v ||
            /^https?:\/\/[^\s/$.?#].[^\s]*$/.test(v) ||
            'Website must be a valid URL',
        ]"
      />
      <v-select
        v-model="company.type"
        :items="company.relations.type"
        item-value="id"
        item-text="name"
        label="Type"
        chips
        deletable-chips
        :rules="[(v) => !!v || 'Type is required']"
        required
      ></v-select>
      <v-checkbox
        v-model="company.isOwnCompany"
        label="Is This Our Own Company?"
      />
      <v-text-field
        v-model="company.email"
        label="Email"
        :rules="[(v) => !v || /.+@.+\..+/.test(v) || 'E-mail must be valid']"
      />
      <v-textarea
        v-model="company.officeAddressEng"
        rows="2"
        label="Office Address (English)"
      />
      <v-textarea
        v-model="company.officeAddressThai"
        rows="2"
        label="Office Address (Thai)"
      />
      <v-text-field v-model="company.officePhone1" label="Office Phone 1" />
      <v-text-field v-model="company.officePhone2" label="Office Phone 2" />
      <v-textarea
        v-model="company.factoryAddressEng"
        rows="2"
        label="Factory Address (English)"
      />
      <v-textarea
        v-model="company.factoryAddressThai"
        rows="2"
        label="Factory Address (Thai)"
      />
      <v-text-field v-model="company.factoryPhone1" label="Factory Phone 1" />
      <v-text-field v-model="company.factoryPhone2" label="Factory Phone 2" />
      <v-text-field
        v-model="company.isoCertifications"
        label="ISO Certifications"
      />
      <div class="mt-4 d-flex justify-space-between">
        <v-btn @click="goBack"> Back </v-btn>
        <v-btn @click="handleSubmit" color="primary" :disabled="!valid">
          {{ id ? "Update" : "Save" }}
        </v-btn>
        <span></span>
      </div>
    </v-form>
  </div>
</template>

<script>
import { getCompany } from "@/services/company";
import { mapActions } from "vuex";

export default {
  props: ["id"],
  data() {
    return {
      loaded: false,
      valid: false,
      company: {
        relations: {
          type: [
            { name: "Customer", id: "CUSTOMER" },
            { name: "Supplier", id: "SUPPLIER" },
          ],
        },
        name: "",
        thaiName: "",
        chineseName: "",
        website: "",
        type: "",
        isOwnCompany: false,
        email: "",
        officeAddressEng: "",
        officeAddressThai: "",
        officePhone1: "",
        officePhone2: "",
        factoryAddressEng: "",
        factoryAddressThai: "",
        factoryPhone1: "",
        factoryPhone2: "",
        isoCertifications: "",
      },
    };
  },
  created() {
    this.setInstance();
  },
  methods: {
    ...mapActions("company", ["createCompany", "updateCompany"]),
    ...mapActions("messages", [
      "addMessage",
      "addErrorMessage",
      "addSuccessMessage",
    ]),

    async handleSubmit() {
      // Validate the form
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.id) {
        let company = { ...this.company };
        delete company.relations;

        this.updateCompany(company)
          .then(() => {
            this.addSuccessMessage("Company was updated successfully");
            this.goBack();
          })
          .catch((error) => {
            const errorMsg =
              error.data && error.data.message
                ? error.data.message
                : "Error updating Company, please try again later";
            this.addErrorMessage(errorMsg);
          });
      } else {
        let company = { ...this.company };
        delete company.relations;

        this.createCompany(company)
          .then(() => {
            this.addSuccessMessage("Company was created successfully");
            this.goBack();
          })
          .catch((error) => {
            const errorMsg =
              error.data && error.data.message
                ? error.data.message
                : "Error creating Company, please try again later";
            this.addErrorMessage(errorMsg);
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    setInstance() {
      if (this.id) {
        this.company.id = this.id;
        getCompany(this.id).then((response) => {
          let instance = response.data;
          for (let property in instance) {
            if (
              Object.prototype.hasOwnProperty.call(instance, property) &&
              Object.prototype.hasOwnProperty.call(this.company, property)
            ) {
              this.company[property] = instance[property];
            }
          }
          this.loaded = true;
        });
      } else {
        this.loaded = true;
      }
      this.setDependencies();
    },
    setDependencies() {},
  },
};
</script>
